// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"StampActionButton_actionButton__2fN_e","ellipsis":"StampActionButton_ellipsis__3lzSG"};